module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin4-55aa6c8ed5509b17d7b3b03204bffdad.jpg";